
import React, { useEffect } from 'react'
import Trusted from '../HomeMain/Trusted/Main'
import Features from '../HomeMain/Features/Main'
import AboutApp from '../HomeMain/AboutApp/Main'
import Design from '../HomeMain/Design/Main'
import Work from '../HomeMain/Work/Main'
import Testimonial from '../HomeMain/Testimonial/Main'
import Pricing from '../HomeMain/Pricing/Main'
import Faq from '../HomeMain/Faq/Main'
import Interface from '../HomeMain/Interface/Main'
import Download from '../HomeMain/Download/Main'
import Story from '../HomeMain/Story/Main'
import Banner from '../Menhomewave/Banner';

const Main = ({ setnavbar, setfooter, setbrdcum }) => {

  useEffect(() => {
    setfooter({ f5: true })
    setbrdcum({ b1: true })
    setnavbar({ n4: true })
    localStorage.setItem("navbar", "homewave")

  }, [])

  return (
    <>
      <Banner />
      <Trusted />
      <Features />
      <AboutApp />
      <Design />
      <Work />
      <Testimonial />
      <Pricing />
      <Faq />
      <Interface />
      <Download />
      <Story />
    </>
  )
}

export default Main